import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App";
import { NasProvider } from "./context/NasContext";
import { applyTheme, getTheme } from "./settings";
import "./styles.css";

applyTheme(getTheme());

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <NasProvider>
        <App />
      </NasProvider>
    </HashRouter>
  </React.StrictMode>
);
